module.exports = __webpack_public_path__ + "e701ca525685087aeb40b7c0a11399f7.svg";